import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FilterListItem, RiskFilterType } from '../../../../models/risk-filter-type';
import { AgilityRiskFilterService } from '../../../../providers/agility-risk-filter.service';
import { TranslateService } from '@ngx-translate/core';
import { ListSortModel, PagedListModel } from '../../../../models/list-sort-model';
import { AgilityRiskSpinnerService } from '../../../../providers/agility-risk-spinner.service';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';
import { Contact } from '../../../../models/contact';

type ContactList = 'PERSONNEL' | 'THIRD_PARTY';
@Component({
  selector: 'lib-select-users',
  templateUrl: './select-users-modal.component.html',
  styleUrls: ['./select-users-modal.component.scss']
})
export class SelectUsersModalComponent implements OnInit {
  filtersForApp: Array<FilterListItem>;
  availableUsers: Array<any>;
  selectedUsers: Array<any> = [];

  pageNumber = 0;
  pageSize = 100;
  filters: Array<RiskFilterType>;
  loadMoreEnabled = true;
  isLoading = false;

  contactList: ContactList = 'PERSONNEL';
  activeContactList: ContactList = 'PERSONNEL';

  sort: Array<ListSortModel> = [
    new ListSortModel('lastName', 'asc'),
    new ListSortModel('firstName', 'asc')];

  constructor(private dynamicDialogRef: DynamicDialogRef,
              private dynamicDialogConfig: DynamicDialogConfig,
              private filterService: AgilityRiskFilterService,
              private translate: TranslateService,
              private spinner: AgilityRiskSpinnerService,
              private messageService: AgilityRiskMessageService,
              private translateService: TranslateService) {
    if (!this.dynamicDialogConfig.header) {
      this.dynamicDialogConfig.header = this.translate.instant('filter.addOrEditRecipients');
    }
    if (!this.dynamicDialogConfig.width) {
      this.dynamicDialogConfig.width = '70%';
    }
  }

  ngOnInit(): void {
    const selectedUsers = this.dynamicDialogConfig?.data?.selectedUsers;
    this.selectedUsers = (!!selectedUsers) ? selectedUsers : [];

    const pageNumber = this.dynamicDialogConfig?.data?.pageNumber;
    this.pageNumber = (!!pageNumber) ? pageNumber : this.pageNumber;

    const pageSize = this.dynamicDialogConfig?.data?.pageSize;
    this.pageSize = (!!pageSize) ? pageSize : this.pageSize;

    // Load the Personnel List on startup
    this.filterService.getFiltersForComponent('lib-select-users').subscribe(filters => {
      this.filtersForApp = filters;
    });

    this.fetchAvailableUsers();
  }

  onApplyFilter(filters: Array<RiskFilterType>): void {
    this.filters = filters;
    this.pageNumber = 0;
    this.availableUsers = null;
    this.fetchAvailableUsers();
  }

  resetPickListState(): void {
    this.availableUsers = [];
    this.filtersForApp = [];
    this.filters = [];
    this.pageNumber = 0;
  }

  loadPersonnelContactsList(): void {
    if (this.activeContactList === 'PERSONNEL') {
      return;
    }

    this.resetPickListState();

    this.filterService.getFiltersForComponent('lib-select-users')
      .subscribe(filters => this.filtersForApp = filters);

    this.activeContactList = 'PERSONNEL';

    this.fetchAvailableUsers();
  }

  loadThirdPartyContactsList(): void {
    if (this.activeContactList === 'THIRD_PARTY') {
      return;
    }

    this.resetPickListState();

    this.filterService.getFiltersForComponent('lib-third-party-users')
      .subscribe(filters => this.filtersForApp = filters);

    this.activeContactList = 'THIRD_PARTY';

    this.fetchAvailableUsers();
  }

  fetchAvailableUsers(): any {
    this.spinner.start();
    this.isLoading = true;

    this.filterService.getFilteredUsers(
      this.filters,
      this.sort,
      this.pageNumber,
      this.pageSize,
      null,
      this.activeContactList === 'THIRD_PARTY'
    ).subscribe({
      next: (result: PagedListModel) => {
        const filteredRes = (result?.content?.length) ? result.content.filter(u => {
          return this.selectedUsers.findIndex(su => su.id === u.id) < 0;
        }) : new Array<RiskFilterType>();

        if (!this.availableUsers) {
          this.availableUsers = new Array<RiskFilterType>();
        }

        this.availableUsers = this.availableUsers.concat(filteredRes);
        this.loadMoreEnabled = (this.availableUsers.length + this.selectedUsers.length) < result.totalElements;

        this.isLoading = false;
      },
      error: err => {
        this.messageService.error(this.translateService.instant('selectUsersModal.failedToLoadFilteredUsers'));
      }
    }).add(() => this.spinner.stop());
  }

  onCancel() {
    this.dynamicDialogRef.destroy();
  }

  onSaveRecipients() {
    this.dynamicDialogRef.close(this.selectedUsers as Contact[]);
  }

  isValid(): boolean {
    let isValid = true;

    if (!this.selectedUsers ||
      this.selectedUsers.length === 0) {
      isValid = false;
    }

    return isValid;
  }

  onLoadMore(): void {
    this.pageNumber++;

    this.fetchAvailableUsers();
  }
}
